import { PUBLIC_API_BASE_PATH } from 'src/constants/environment';
import type { TaxonomyContentEntry } from 'src/redux/content/types';
import { logger } from 'src/utils/serverLogger';
import { encodePathQueryParam } from './encodePathQueryParam';

/** Client-side fetch of a single taxonomy_plp content entry via the public API route. */
export const fetchTaxonomyPlpContentEntry = async (
  path: string,
): Promise<TaxonomyContentEntry | null> => {
  try {
    const res = await fetch(
      `${PUBLIC_API_BASE_PATH}taxonomy-plp-content?path=${encodePathQueryParam(path)}`,
    );

    if (!res.ok) {
      logger.error('fetchTaxonomyPlpContentEntry: non-ok response', { path, status: res.status });

      return null;
    }

    const data = (await res.json()) as { content?: TaxonomyContentEntry | null };

    return data.content ?? null;
  } catch (error) {
    logger.error('fetchTaxonomyPlpContentEntry: request failed', {
      path,
      message: error instanceof Error ? error.message : String(error),
    });

    return null;
  }
};
